export enum AxisMode {
  RELATIVE = 'RELATIVE',
  ABSOLUTE = 'ABSOLUTE'
}
